<template>
    <div>
        <input type="checkbox" :name="firstLast + inputId" style="transform: scale(1.3)" @click="checkedBox" :checked="checked" :disabled="isDisabled">
        
    </div>
</template>

<script>

export default {
    name: "FirstLastClass",

    props: {
        firstLast: {

        },
        inputId: {

        },
        startChecked:{

        },
        startDisabled:{

        }
    },

    data() {
        return {
            checked: this.startChecked == 1 ? true : false,
            isDisabled: this.startDisabled == 1 ? true : false,
        }
    },

    mounted() {
        EventBus.$on('checked-first-last', (incomingBox) => {
            
            if(incomingBox.fl != this.firstLast && incomingBox.id == this.inputId){
                this.isDisabled = incomingBox.checked;
                
                /* 
                Before turning these checkboxes into a component, some of the data had both first and last checked- the code in the blade doesn't disable the checkboxes if they're both checked so that if both are checked, then someone unchecks 'last' and then checks it again, it will clear out 'first' checkbox (preventing both from being checked once one is unchecked)
                */ 
                if(incomingBox.checked){
                    let input = document.getElementsByName(this.firstLast + this.inputId)[0];
                    input.checked = false;
                }
            }
        });
    },

    methods: {
        checkedBox(){
            let input = document.getElementsByName(this.firstLast + this.inputId)[0];
            //console.log("value: " + input.checked);

            EventBus.$emit('checked-first-last', {"fl": this.firstLast, "id": this.inputId, 'checked': input.checked});
        }
    }
}
</script>

<style>

</style>